/**
 * @module
 *
 * @author Jacob Viertel [jv@onscreen.net](mailto:jv@onscreen.net)
 *
 * @since 3.84.0
 *
 * @import {STYLE_OPEN, STYLE_CLOSED} from '../service/style.js';
 */

// bounty
import {onClick} from '@acng/frontend-bounty/dom/document.js';
// stargazer, rubicon
import {AttributeSetup} from '@acng/frontend-stargazer';
import {IS, guard} from '@acng/frontend-rubicon';
// nova
import {closeAll} from '../service/auto-close.js';

/**
 * Automatically close areas of the website when clicked somewhere else.
 *
 * `*[auto-close]` will be _closed_ if you click anywhere outside.
 *
 * - Add `layout-closed` class entry.
 * - Remove `layout-open` class entry.
 * - Remove `open` attribute, if it is a HTMLDetailsElement.
 *
 * Optionally define css classes as attribute value that are used by the "auto
 * closer" to additionally qualify this element for auto-close.
 *
 * ## Formal Syntax
 *
 *     auto-close = <selectors>
 *
 * @example
 *
 * ```html
 * <details auto-close>
 *   <summary>Pop it like it's hot</summary>
 *   When the pimp's in the crib ma<br />
 *   Drop it like it's hot
 * </details>
 * ```
 *
 * @see {@link closeAll | The "auto closer"}
 * @see {@link STYLE_OPEN | `.layout-open`}
 * @see {@link STYLE_CLOSED | `.layout-closed`}
 */
const attributeName = 'auto-close';

AttributeSetup(attributeName, () =>
  onClick(({target}) => {
    ASSERT: guard(target, IS(Element), 'click-target');

    closeAll(target);
  }),
);

export {attributeName as AUTO_CLOSE};
